"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CometForVenus = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const SelectPlayer_1 = require("../../inputs/SelectPlayer");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class CometForVenus extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.COMET_FOR_VENUS,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.SPACE],
            cost: 11,
            tr: { venus: 1 },
            metadata: {
                description: 'Raise Venus 1 step. Remove up to 4M€ from any player WITH A VENUS TAG IN PLAY.',
                cardNumber: '218',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.venus(1).nbsp().nbsp().minus().megacredits(4).secondaryTag(Tags_1.Tags.VENUS).any;
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        const venusTagPlayers = player.game.getPlayers().filter((otherPlayer) => otherPlayer.id !== player.id && otherPlayer.getTagCount(Tags_1.Tags.VENUS, 'raw') > 0);
        if (player.game.isSoloMode() || venusTagPlayers.length === 0) {
            player.game.increaseVenusScaleLevel(player, 1);
            return undefined;
        }
        if (venusTagPlayers.length > 0) {
            return new OrOptions_1.OrOptions(new SelectPlayer_1.SelectPlayer(Array.from(venusTagPlayers), 'Select player to remove up to 4 M€ from', 'Remove M€', (selectedPlayer) => {
                selectedPlayer.deductResource(Resources_1.Resources.MEGACREDITS, 4, { log: true, from: player });
                player.game.increaseVenusScaleLevel(player, 1);
                return undefined;
            }), new SelectOption_1.SelectOption('Do not remove M€', 'Confirm', () => {
                player.game.increaseVenusScaleLevel(player, 1);
                return undefined;
            }));
        }
        return undefined;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, venusIncrease: 1 });
    }
}
exports.CometForVenus = CometForVenus;
//# sourceMappingURL=CometForVenus.js.map